export default __webpack_public_path__ + "static/media/boutiqeFace.c4a0044f.jpg";